<div class="hotkey-page">
  <header class="hotkey-header">
    <div class="hotkey-header__identity">
      <div class="hotkey-header__icon" aria-hidden="true">
        <i class="pi pi-key"></i>
      </div>

      <div class="hotkey-header__copy">
        <h1>Shortcuts</h1>
        <p>Component &amp; detail library <span>&middot;</span> Updated just now</p>
      </div>
    </div>

    <div class="hotkey-header__status" aria-label="Shortcuts ready">
      <span class="hotkey-header__status-dot"></span>
      <span>Shortcut controls</span>
    </div>
  </header>

  <div class="hotkey-content">
    <div class="surface-card shadow-2 w-full overflow-auto">
      <app-hotkeys></app-hotkeys>
    </div>
  </div>
</div>
